import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgLocationFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 3v2c0 .024 0 .047.002.07A7.004 7.004 0 0 0 5.071 11H3a1 1 0 1 0 0 2h2.07a7.005 7.005 0 0 0 5.932 5.93A1.029 1.029 0 0 0 11 19v2a1 1 0 1 0 2 0v-2c0-.024 0-.047-.002-.07A7.005 7.005 0 0 0 18.929 13H21a1 1 0 1 0 0-2h-2.07a7.004 7.004 0 0 0-5.932-5.93A1.03 1.03 0 0 0 13 5V3a1 1 0 1 0-2 0Zm3 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", fill: color }));
};
export default factorySvgIcon(SvgLocationFilled);
//# sourceMappingURL=SvgLocationFilled.js.map